import { jsx as _jsx } from "react/jsx-runtime";
// frontend/src/components/AgentsBoard/TaskTypesEditor.tsx
// Autocomplete has no @weave-mui equivalent — matches GithubReposEditor/SlackChannelPicker's existing precedent.
import { Autocomplete } from '@mui/material';
import { TextField } from '@weave-mui/material';
export const MAX_TASK_TYPES = 20;
/** taskType has no formal enum (backend/task-core/models/Task.ts) — these are just the two
 * live/creatable values in use today (fixpr, research). `freeSolo` still allows a value not
 * in this list since nothing enforces the vocabulary server-side. nudgePr is deliberately not
 * offered here — it can never be assigned to an agent (AgentService.patch rejects it).
 * Also reused by AgentSidebar as the UI-only pre-filled default for an unconfigured agent. */
export const KNOWN_TASK_TYPES = ['fixpr', 'research'];
/** Add/remove list of taskTypes an agent is scoped to claim. Each add/remove is its own
 * committed onChange call, matching GithubReposEditor/SlackChannelPicker's immediate-save
 * semantics rather than requiring a separate save step — so `value` may show a UI-only
 * default (see AgentSidebar) without anything being persisted until the user actually
 * interacts with the field. */
export default function TaskTypesEditor({ value, onChange }) {
    const atCap = value.length >= MAX_TASK_TYPES;
    return (_jsx(Autocomplete, { multiple: true, freeSolo: true, size: "small", options: KNOWN_TASK_TYPES, value: value, onChange: (_e, newValue) => {
            const deduped = Array.from(new Set(newValue.map((v) => v.trim()).filter(Boolean)));
            onChange(deduped.slice(0, MAX_TASK_TYPES));
        }, renderInput: (params) => (_jsx(TextField, { ...params, label: "Task types", helperText: atCap ? `Maximum ${MAX_TASK_TYPES} task types` : 'e.g. fixpr, research — press Enter to add' })) }));
}
